// Base
var config = {
  patchName: "unknown firefly",
  partialsConfig: [
    0.4459247628953637,
    0.25786885449063723,
    0.29664276424832164,
    0.0036663104841537122,
    0.1158284019682577,
    0.5296165337087044,
    0.28860737833217015,
    0.18716679485811946,
    0.038823413737473535,
  ],
  envelopeConfig: {
    attack: 1.259028203005203,
    decay: 0.6831902588523038,
    sustain: 0.4551602007981821,
    release: 8.4451998928986365,
  },
  eq3Config: {
    low: -10.148165065673282,
    lowFrequency: 278.8487700265473,
    mid: -16.65041269755158,
    high: -17.95842545817374,
    highFrequency: 1469.1810758794095,
  },
  chorusConfig: {
    delayTime: 1.6831875720732303,
    depth: 0.3381778704040248,
    feedback: 0.16277546443941524,
    frequency: 0.8992020113467434,
    spread: 85.97308589789883,
    wet: 0.0268817169560977,
  },
  tremoloConfig: {
    frequency: 0.3437667882460671,
    depth: 0.5972923540553017,
    spread: 86.97902325898369,
    wet: 0.08750310640559261,
  },
  vibratoConfig: {
    maxDelay: 0.006048814042943114,
    frequency: 2.007639933848706,
    depth: 0.30947600491634364,
    wet: 0.5429497450376983,
  },
  pingPongDelayConfig: {
    delayTime: 0.25510680625872406,
    maxDelay: 3.003482599832142,
    wet: 0.54662101063470304,
  },
  reverbConfig: { decay: 0.7841959740645533, wet: 0.782080925302147 },
  distortion: {
    distortion: 0.1,
    wet: 0.4
  },
  feedbackDelayConfig: {
    delay: 0.17092400477839886,
    feedback: 0.410965696739396,
  },
  autoPanner: { frequency: 0.6 },
  gainConfig: { gain: 0.25 },
};

export { config };
